import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const Nav = ({ content, navIndex, setNavIndex, swiperChange }) => {
    const navRef = useRef(null);

    useEffect(() => {
        // 页面滚动隐藏nav 页面停止滚动显示nav
        let timeoutId = null;

        const handleScroll = () => {
            const nav = navRef.current;

            nav.style.opacity = 0;

            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                // eslint-disable-next-line no-undef
                TweenLite.to(nav, 0.5, { opacity: 1, ease: Power2.easeInOut });
            }, 100);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearTimeout(timeoutId);
        };
    }, []);

    return (
        <div className={styles.nav} ref={navRef}>
            <div
                className={`${styles.item}`}
                onClick={() => {
                    // setNavIndex(0);
                    window.scroll({ top: 0, behavior: 'smooth' });
                }}>
                首页
            </div>
            {content.map((item, index) => {
                return (
                    <div
                        key={index}
                        className={`${styles.item} ${navIndex === index ? styles.active : ''}`}
                        onClick={() => {
                            setNavIndex(index);
                            swiperChange(index);
                        }}>
                        {item.userName}
                    </div>
                );
            })}
        </div>
    );
};

Nav.propTypes = {
    content: PropTypes.array,
    navIndex: PropTypes.number,
    setNavIndex: PropTypes.func,
    swiperChange: PropTypes.func,
};

export default errorBoundary(Nav);
